import { boolean, mixed, string } from 'yup';

import { getSchema } from '@utils/schemaUtils';

import { mandatoryErrMessage } from '@constants/validationConstants';

export const channelFields = {
	isEmail: mixed()
		.nullable()
		.test('isEmailOrNotification', mandatoryErrMessage('Channel') as string, function (value, context) {
			return Boolean(value || context.parent.isNotification);
		}),
	isNotification: boolean()
		.nullable()
		.test('isEmailOrNotification', mandatoryErrMessage('Channel') as string, function (value, context) {
			return Boolean(value || context.parent.isEmail);
		}),
	messageTitle: string().nullable().required(mandatoryErrMessage('Message title')),
	messageBody: string().nullable(),
};

export const channelSchema = getSchema(channelFields);
